import { useParams } from 'react-router-dom';

import { TriggeredMessagesTableContainer } from './components/triggered-messages-table.container';

export const TriggeredMessagesListScoped = () => {
  const { scope } = useParams<{ scope: string }>();

  return <TriggeredMessagesTableContainer scope={scope} />;
};
